module.exports = __webpack_public_path__ + "img/5.be9cc662.jpg";